import axios from '../helpers/axios'
import { logError } from '../services';
import { IAttorneyOffice, IAttorneyOfficePost, IAttorneyOfficeUser } from '../models';

export const getAdminAttorneyOffices = async (): Promise<IAttorneyOffice[]> => {
  try {
    const { data } = await axios.get(`/api/admin/attorney-offices`);
    return data;
  } catch (error) {
    logError(error, 'getAdminAttorneyOffices failed');
    return Promise.reject(error);
  }
};

export const updateAdminAttorneyOffice = async (post: IAttorneyOfficePost): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/admin/attorney-offices`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'updateAdminAttorneyOffice failed'
    );
    return Promise.reject(error);
  }
};

export const deleteAdminAttorneyOffice = async (attorneyOfficeId: number): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/admin/attorney-offices/${attorneyOfficeId}`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getAdminAttorneyOfficeUsers = async (attorneyOfficeId: number): Promise<IAttorneyOfficeUser[]> => {
  try {
    const { data } = await axios.get(`/api/admin/attorney-offices/${attorneyOfficeId}/users`);
    return data;
  } catch (error) {
    logError(error, 'getAdminAttorneyOfficeUsers failed');
    return Promise.reject(error);
  }
};

export const updateAdminAttorneyOfficeUser = async (attorneyOfficeId: number, personId: number): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/admin/attorney-offices/${attorneyOfficeId}/users`, personId, { headers: { 'Content-Type': 'application/json' } });
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          attorneyOfficeId,
          personId
        }
      },
      'updateAdminAttorneyOfficeUser failed'
    );
    return Promise.reject(error);
  }
};

export const deleteAdminAttorneyOfficeUser = async (attorneyOfficeId: number, personId: number): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/admin/attorney-offices/${attorneyOfficeId}/users/${personId}`);
    return data;
  } catch (error) {
    logError(error, 'deleteAdminAttorneyOfficeUser failed');
    return Promise.reject(error);
  }
};
